import { useEffect } from 'react';

const tabIdKey = 'tab_id';

const RELOAD_BROADCAST_EVENT_TYPE = 'RELOAD_BROADCAST';

const broadcastChannel =
  'BroadcastChannel' in window ? new BroadcastChannel('fulfillment-tools-channel') : undefined;

type ReloadEvent = MessageEvent<{ type: string; senderId: string }>;

function getTabId() {
  const senderId = sessionStorage.getItem(tabIdKey) || crypto.randomUUID();
  sessionStorage.setItem(tabIdKey, senderId);
  return senderId;
}

function handleMessage(event: ReloadEvent) {
  const tabId = getTabId();
  if (event.data?.type === RELOAD_BROADCAST_EVENT_TYPE && event.data?.senderId !== tabId) {
    document.location.reload();
  }
}

export function useBroadcastReload() {
  useEffect(() => {
    if (broadcastChannel) {
      broadcastChannel.addEventListener('message', handleMessage);
    }
    return () => broadcastChannel?.removeEventListener('message', handleMessage);
  }, []);

  return () => {
    broadcastChannel?.postMessage({
      type: RELOAD_BROADCAST_EVENT_TYPE,
      senderId: getTabId(),
    });
  };
}
